export default __webpack_public_path__ + "static/media/our-services-social-care-children-residential-01.e25a8932.jpg";